import * as x from "react";
import { i as h, E as v, x as c, a as p, r as m, c as u } from "../createReactComponent-58f9bea8.mjs";
import { n as l } from "../property-9daa16cd.mjs";
import { e as g } from "../query-d94c86d2.mjs";
import { e as d } from "../class-map-2994e95e.mjs";
import { r as w } from "../icon-c572aa57.mjs";
import { r as f } from "../icon-button-87ac6b5d.mjs";
import { g as y } from "../utils-cf5bbdd1.mjs";
import "../base-e16d29d8.mjs";
import "../tooltip-cb602d1f.mjs";
const k = h`
  :host .alert-newbanner,
  .alert-inline,
  .alert-subtle,
  .alert-banner {
    text-align: left;
    width: 100%;
    color: var(--exo-color-font);
    outline: none;
    font: var(--exo-text-body-medium);
    cursor: text;
    box-sizing: border-box;
    display: flex;
    gap: var(--exo-spacing-x-small);
  }

  :host .alert-banner {
    position: relative;
    padding: var(--exo-spacing-small) var(--exo-spacing-2x-large);
    visibility: hidden;
  }

  :host .alert-newbanner {
    position: fixed;
    left: var(--exo-spacing-none);
    min-width: calc(var(--exo-size-1) * 4 + var(--exo-size-1) / 2);
    min-height: calc(calc(var(--exo-size-6) - var(--exo-size-5)) / 2);
    box-shadow: var(--exo-spacing-none) var(--exo-spacing-small)
      var(--exo-spacing-x-large) var(--exo-spacing-none)
      var(--exo-color-shadow-strong);
    border-radius: var(--exo-spacing-none);
    padding: var(--exo-spacing-small) var(--exo-spacing-standard);
    top: var(--exo-spacing-none);
    z-index: var(--exo-z-index-tooltip-popup);
  }

  :host .alert-inline {
    min-height: calc(calc(var(--exo-size-6) - var(--exo-size-5)) / 2);
    border-radius: calc(2 * var(--exo-radius-small));
    padding: var(--exo-spacing-x-small) var(--exo-spacing-x-small)
      var(--exo-spacing-x-small) var(--exo-spacing-small);
  }

  :host .alert-subtle {
    min-height: calc(calc(var(--exo-size-6) - var(--exo-size-5)) / 4);
    gap: var(--exo-spacing-x-small);
    align-items: center;
    border-radius: calc(2 * var(--exo-radius-small));
    padding: var(--exo-spacing-x-small) var(--exo-spacing-small)
      var(--exo-spacing-x-small) var(--exo-spacing-x-small);
  }

  :host .alert-banner.alert-banner--info {
    background-color: var(--exo-color-background-info);
  }

  :host .alert-banner.alert-banner--success,
  .alert-subtle--success,
  .alert-inline--success,
  .alert-newbanner--success {
    background-color: var(--exo-color-background-success);
  }

  :host .alert-banner.alert-banner--warning,
  .alert-subtle--warning,
  .alert-inline--warning,
  .alert-newbanner--warning {
    background-color: var(--exo-color-background-warning);
  }

  :host .alert-banner.alert-banner--error {
    background-color: var(--exo-color-border-danger-weak);
  }

  :host .alert-banner.alert-banner--opened {
    visibility: visible;
  }

  :host .alert-banner ex-icon {
    position: absolute;
    top: calc(var(--exo-spacing-medium) / 2);
  }

  :host .alert-banner .alert-banner__icon {
    left: calc(var(--exo-spacing-medium) / 2);
  }

  :host .banner__container {
    display: flex;
    padding: var(--exo-spacing-2x-small) var(--exo-spacing-none);
    align-items: flex-start;
    gap: var(--exo-spacing-x-small);
    flex: 1 0 0;
  }

  :host .slotclass {
    display: flex;
    width: 100%;
    line-height: calc(
      var(--exo-line-height-body) + var(--exo-spacing-3x-small)
    );
  }

  /* FOR ICONS */

  :host .alert-subtle--information {
    background-color: var(--exo-color-background-secondary);
  }

  :host .alert-subtle--error,
  .alert-inline--error,
  .alert-newbanner--error {
    background-color: var(--exo-color-background-danger-weak);
  }

  :host .alert-inline--information {
    background-color: var(--exo-color-background);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-info-strong);
  }

  :host .alert-inline--success {
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-success-strong);
  }

  :host .alert-inline--warning {
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-warning-strong);
  }

  :host .alert-inline--error {
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-danger-strong);
  }

  :host .alert-newbanner.alert-newbanner--information {
    background-color: var(--exo-color-background-secondary);
    border-bottom: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-info-strong);
  }

  :host .alert-newbanner.alert-newbanner--success {
    border-bottom: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-success-strong);
  }

  :host .alert-newbanner.alert-newbanner--warning {
    border-bottom: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-warning-strong);
  }

  :host .alert-newbanner.alert-newbanner--error {
    border-bottom: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-danger-strong);
  }

  /* FOR ICONS */

  :host .alert-newbanner__icon--information,
  .alert-inline__icon--information,
  .alert-subtle__icon--information {
    color: var(--exo-color-background-info-strong);
  }

  :host .alert-newbanner__icon--success,
  .alert-subtle__icon--success,
  .alert-inline__icon--success {
    color: var(--exo-color-background-success-strong);
  }

  :host .alert-newbanner__icon--warning,
  .alert-inline__icon--warning,
  .alert-subtle__icon--warning {
    color: var(--exo-color-background-warning-strong);
  }

  :host .alert-newbanner__icon--error,
  .alert-inline__icon--error,
  .alert-subtle__icon--error {
    color: var(--exo-color-background-danger-strong);
  }

  /* Alert Animation */

  :host .alert-newbanner.alert-newbanner--opened {
    animation: banner-slide var(--exo-time-standard) ease forwards;
  }

  @keyframes banner-slide {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }

  :host .alert-inline.alert-inline--opened,
  .alert-subtle.alert-subtle--opened {
    animation: banner-fade var(--exo-time-standard) ease forwards;
  }

  @keyframes banner-fade {
    from {
      transform: translateY(-100%);
      opacity: var(--exo-opacity-1);
    }
    to {
      transform: translateY(0);
      opacity: var(--exo-opacity-0);
    }
  }

  :host .alert-newbanner.alert-newbanner--hide {
    animation: banner-hide var(--exo-time-standard) ease forwards;
  }

  :host .alert-inline.alert-inline--hide,
  .alert-subtle.alert-subtle--hide {
    animation: banner-hide var(--exo-time-standard) ease forwards;
  }

  @keyframes banner-hide {
    from {
      transform: translateY(0);
      opacity: 1;
    }
    to {
      transform: translateY(-150%);
      opacity: 0;
      display: none;
    }
  }
`;
var _ = Object.defineProperty, I = Object.getOwnPropertyDescriptor, n = (e, a, s, o) => {
  for (var i, t = o > 1 ? void 0 : o ? I(a, s) : a, b = e.length - 1; b >= 0; b--)
    (i = e[b]) && (t = (o ? i(a, s, t) : i(t)) || t);
  return o && t && _(a, s, t), t;
}, $ = ((e) => (e.INFO = "Information", e.SUCCESS = "Success", e.WARNING = "Warning", e.ERROR = "Error", e))($ || {}), C = ((e) => (e.NONE = "none", e.NEWBANNER = "newbanner", e.INLINE = "inline", e.SUBTLE = "subtle", e))(C || {});
class r extends v {
  constructor() {
    super(...arguments), this.type = "Information", this.open = !1, this.hideClose = !1, this.tooltipText = "", this.alertIconLabel = "";
  }
  getAlertIcon() {
    return c`<ex-icon
      class=${d({ "alert-banner__icon": this.variant === "none" || !this.variant, [this.getIconType()]: this.variant })}
      size="S"
      icon=${this.type}
      label=${this.alertIconLabel}
    ></ex-icon>`;
  }
  getIconType() {
    return `alert-${this.variant}__icon--${this.type.toLowerCase()}`;
  }
  getAlertVariant() {
    return `alert-${this.variant}`;
  }
  getAlertBackground() {
    return `alert-${this.variant}--${this.type.toLowerCase()}`;
  }
  showBanner() {
    return this.open !== !1 ? `alert-${this.variant}--opened` : `alert-${this.variant}--hide`;
  }
  close() {
    var a, s, o, i;
    this.variant === "newbanner" ? ((a = this.newBanner) == null || a.classList.replace("alert-newbanner--opened", "alert-newbanner--hide"), this.open = !1, this.dispatchEvent(new CustomEvent("onClose", { detail: { open: this.open } })), document.body.style.overflow = "unset", (s = this.triggerElement) == null || s.focus()) : (this.open = !1, (o = this.alertInline) == null || o.classList.replace("alert-inline--opened", "alert-inline--hide"), this.dispatchEvent(new CustomEvent("onClose", { detail: { open: this.open } })), document.body.style.overflow = "unset", (i = this.triggerElement) == null || i.focus());
  }
  getCloseIcon() {
    return !this.hideClose && ["inline", "newbanner"].includes(this.variant) ? c`<ex-icon-button
          icon="Close"
          type="tertiary"
          id="closebutton"
          @click=${this.close}
          tooltipText=${this.tooltipText}
          data-exo-locatorId-suffix=${y(this, "alert-banner-close-button")}
        ></ex-icon-button>` : "";
  }
  getSlot() {
    return this.variant === "newbanner" || this.variant === "inline" ? c`<slot name="button"></slot>` : p;
  }
  getBanners() {
    return this.variant && this.variant !== "none" ? c`
        <div
          class=${d({ [this.getAlertBackground()]: !0, [this.getAlertVariant()]: !0, [this.showBanner()]: !0 })}
          aria-hidden="${!this.open}"
          id="hint"
        >
          <div class="banner__container">
            ${this.getAlertIcon()}
            <slot
              class=${d({ slotclass: !0, "slotclass--subtle": this.variant === "subtle" })}
            ></slot>
          </div>
          ${this.getSlot()} ${this.getCloseIcon()}
        </div>
      ` : c`
      <div
        class=${d({ "alert-banner": !0, "alert-banner--info": this.type === "Information", "alert-banner--success": this.type === "Success", "alert-banner--warning": this.type === "Warning", "alert-banner--error": this.type === "Error", "alert-banner--opened": this.open })}
        aria-hidden="${!this.open}"
      >
        ${this.getAlertIcon()}
        <slot></slot>
      </div>
    `;
  }
  render() {
    return this.triggerElement = (document == null ? void 0 : document.activeElement) || p, this.getBanners();
  }
}
r.styles = k, n([l()], r.prototype, "type", 2), n([g("slot")], r.prototype, "defaultSlot", 2), n([l({ type: Boolean, reflect: !0 })], r.prototype, "open", 2), n([l()], r.prototype, "variant", 2), n([l({ type: Boolean })], r.prototype, "hideClose", 2), n([l()], r.prototype, "tooltipText", 2), n([g(".alert-newbanner")], r.prototype, "newBanner", 2), n([g(".alert-inline")], r.prototype, "alertInline", 2), n([l({ type: String })], r.prototype, "alertIconLabel", 2);
const E = (e = "") => {
  m("ex-alert-banner", r, e), f(e), w(e);
}, Y = u({ tagName: "ex-alert-banner", elementClass: r, react: x, events: { onClose: "onClose" }, displayName: "ExAlertBanner", registerWebComponent: E });
export {
  $ as AlertBannerType,
  C as AlertBannerVariant,
  Y as ExAlertBanner,
  E as register
};
